import { ContentChild, Directive, forwardRef, Inject, ViewContainerRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LinkElementComponent } from "../link-element/link-element.component";
import { WidgetWithExpandableDetails } from "./widget-with-expandable-details.component";

@Directive()
export abstract class WidgetWithLinkAndExpandableDetails extends WidgetWithExpandableDetails {

    @ContentChild(LinkElementComponent) link: LinkElementComponent;

    constructor(
        @Inject(forwardRef(() => MatDialog)) protected dialog: MatDialog,
        @Inject(forwardRef(() => ViewContainerRef)) vcRef: ViewContainerRef
    ) {
        super(dialog, vcRef);
    }
}